(function($) {
  'use strict';

  let $theLink = $(".jump-link");

  function jumpToHash(e) {
    e.preventDefault();
    const scrolled = $(window).scrollTop();

    if( scrolled > 93 ) {
      $("html, body").animate({
        scrollTop: $( $(this).attr('href') ).offset().top - 150
      }, 900, 'easeOutExpo');
    } else {
      $("html, body").animate({
        scrollTop: $( $(this).attr('href') ).offset().top - 150
      }, 900, 'easeOutExpo');
    }
  }

  $theLink.each(function() {
    $(this).on('click', jumpToHash);
  });

})(jQuery);
